<!-- eslint-disable no-unused-vars -->
<template>
  <b-card title="" class="text-left">
    <b-form @submit.prevent="updateItem">
      <!-- Projeto -->
      <!-- <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label
              for="projectSelect"
              class="text-center font-weight-bold text-primary"
            >
              Projeto :
            </label>
            <b-form-select
              id="projectSelect"
              v-model="item.project_name"
              :options="projects"
              value-field="id"
              text-field="name"
              placeholder="Selecione um projeto"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row> -->

      <b-row
        v-if="editingType === 'project' || is_project"
        class="my-1 m-2 pl-2 pr-2 text-left justify-content-center"
      >
        <b-col cols="12">
          <b-form-group>
            <label
              for="projectSelect"
              class="text-center font-weight-bold text-primary"
            >
              Projeto :
            </label>

            <div
              @click="handleShowArquived()"
              :style="{ color: 'blue', padding: '5px 0', cursor: 'pointer' }"
            >
              {{ showArquivded ? 'Ocultar arquivados' : 'Mostrar arquivados' }}
            </div>

            <v-select
              ref="vselect_project"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder="Selecione um projeto"
              v-model="item.project_id"
              :options="projects"
              label="name"
              :searchable="true"
              :reduce="(project) => project.id"
            />
            <p v-if="$v.item.project_id.$error" style="color: red">
              *O projeto é necessário.
            </p>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row
        v-if="!isSalaryUpdate"
        class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
      >
        <b-col cols="12">
          <label for="category" class="font-weight-bold text-primary"
            >Fornecedor :</label
          >

          <v-select
            ref="vselect_supplier"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            placeholder="Selecione uma categoria"
            v-model="item.supplier_id"
            :options="supplier"
            label="supplier_name"
            :searchable="true"
            :reduce="(supplier) => supplier.id"
          />
          <p v-if="$v.item.supplier_id.$error" style="color: red">
            *Um fornecedor é necessário.
          </p>
        </b-col>
      </b-row>
      <b-row
        v-if="!isSalaryUpdate"
        class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
      >
        <b-col cols="12">
          <b-form-group class="mb-2">
            <label for="category" class="font-weight-bold text-primary"
              >Categoria do custo
            </label>

            <v-select
              ref="vselect"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder="Selecione uma categoria"
              v-model="item.expense_category_id"
              :options="categories"
              label="expense_category_name"
              :searchable="true"
              :reduce="(category) => category.id"
            />
            <p v-if="$v.item.expense_category_id.$error" style="color: red">
              *Uma categoria é necessária.
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="!isSalaryUpdate"
        class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
      >
        <b-col cols="12">
          <b-form-group>
            <label for="value" class="text-center font-weight-bold text-primary"
              >Valor :</label
            >

            <b-input-group append="R$">
              <BFormInput
                id="value"
                type="text"
                v-model="item.value"
                v-money="moneyMask"
              ></BFormInput>
              <div
                v-if="$v.item.value.$error"
                style="color: red"
                class="d-block"
              >
                *Valor precisa ser maior que zero.
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Data Refrencia -->

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="date" class="font-weight-bold text-primary"
              >Data de Referência :</label
            >
            <BFormInput
              id="date"
              type="date"
              v-model="item.reference_date"
            ></BFormInput>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Data Transação -->

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="date" class="font-weight-bold text-primary"
              >Data da Transação :</label
            >
            <BFormInput
              id="date"
              type="date"
              v-model="item.transaction_date"
            ></BFormInput>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Status -->
      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="status" class="font-weight-bold text-primary"
              >Status :</label
            >
            <b-form-select
              id="status"
              v-model="item.status"
              :options="statusOptions"
              placeholder="Selecione o status"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Parcelas -->
      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="status" class="font-weight-bold text-primary"
              >Parcelas:</label
            >
            <BFormInput
              disabled
              id="installments"
              type="text"
              v-model="item.installments"
            ></BFormInput>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Descrição -->

      <b-row class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center">
        <b-col cols="12">
          <b-form-group>
            <label for="description" class="font-weight-bold text-primary"
              >Descrição :</label
            >
            <BFormTextarea
              id="description"
              type="textarea"
              v-model="item.description"
            ></BFormTextarea>
          </b-form-group>
        </b-col>
      </b-row>
      <div :style="{ gap: '20px' }" class="justify-center">
        <BButton variant="outline" @click="handleReturn()">Voltar</BButton>
        <BButton variant="danger" @click="showModal = true">Excluir</BButton>
        <BButton type="submit" variant="primary">Salvar</BButton>
      </div>
    </b-form>

    <b-modal
      id="delete-confirmation"
      v-model="showModal"
      title="Confirmação"
      centered
      ok-title="Sim"
      cancel-title="Cancelar"
      @ok="deleteItem"
    >
      Tem certeza que deseja excluir este item?
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BCol,
  BRow,
  BFormSelect,
  BInputGroup,
} from 'bootstrap-vue';
import { useVuelidate } from '@vuelidate/core';
import { requiredIf, required } from '@vuelidate/validators';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { VBTooltip } from 'bootstrap-vue';

export default {
  name: 'expense-edit',
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    id: { type: Number },
  },
  components: {
    BCard,
    BFormInput,
    BCol,
    BRow,
    BForm,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BButton,
    BInputGroup,
  },
  data: () => ({
    is_project: false,
    haveInstallments: false,
    supplier: [],
    showArquivded: false,
    showModal: false,
    categories: [],
    item: { project_name: '', transaction_date: '01/01/2023' },
    installments: [],
    projects: [],
    date: '21/08/2023',
    statusOptions: ['previsto', 'realizado'],
    moneyMask: {
      prefix: 'R$ ',
      suffix: '',
      thousands: '.',
      decimal: ',',
      precision: 2,
      masked: false,
    },
  }),
  validations() {
    return {
      item: {
        project_id: {
          required: requiredIf(function () {
            return this.is_project_expense == true;
          }),
        },
        expense_category_id: {
          required,
        },
        supplier_id: {
          required: requiredIf(function () {
            return this.isSalaryUpdate == false;
          }),
        },
        value: {
          required,
          notZero: (value) => value !== '0,00',
        },
      },
    };
  },

  setup() {
    return { $v: useVuelidate() };
  },

  created() {
    this.getItem();
    this.getProjects();
    this.getCategories();
    this.getSupplier();
    console.log(this.editingType);
  },

  computed: {
    editingType() {
      return this.$store.getters.editingExpenseType;
    },
    isSalaryUpdate() {
      return this.item?.expenseCategory?.expense_category_name ===
        'Salários Equipe técnica'
        ? true
        : false;
    },
  },

  methods: {
    handleReturn() {
      if (this.id) {
        this.$emit('closeModal');
      } else {
        this.$router.go(-1);
      }
    },

    async getSupplier() {
      await this.$store
        .dispatch('getAllSuppliers', {
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          if (resp) {
            this.supplier = resp;
          }
        });
    },
    async getItem() {
      this.$store
        .dispatch('getExpense', {
          id: this.$route?.params?.id ? this.$route.params.id : this.id,

          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          const item = {
            ...resp,
            supplier_id: resp?.supplier?.id || null,
            expense_category_id: resp?.expenseCategory?.id || null,
            value: this.numberToMonetary(resp.value),
            reference_date: this.dateFormatter(
              resp.reference_date,
              'yyyy-MM-dd',
            ),
            transaction_date: this.dateFormatter(
              resp.transaction_date,
              'yyyy-MM-dd',
            ),
            created_at: this.dateFormatter(resp.created_at),
            updated_at: this.dateFormatter(resp.updated_at),
            installments:
              resp.installments.length > 0
                ? 'Sim, ' +
                  resp.installments.length +
                  ' parcelas de ' +
                  'R$ ' +
                  this.numberToMonetary(resp.installments[0].value)
                : 'Não',
          };
          this.item = item;
          this.haveInstallments = item.installments;

          if (this.item?.project_id) {
            this.is_project = true;
          }
          this.installments = resp.installments;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async deleteItem() {
      let id = this.$route?.params?.id ? this.$route.params.id : this.id;
      this.$store
        .dispatch('destroyExpense', id)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'despesa excluida com sucesso.',
              icon: 'SuccessIcon',
              variant: 'success',
            },
          });
          if (this.id) {
            this.$emit('closeModal');
          } else {
            this.$router.push('/lancamento-de-receita');
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao excluir despesa.',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },

    async getProjects() {
      let body = {
        id: this.$route.params.id,
        workspace_id: this.$store.getters.currentWorkspace.id,
        page: 1,
        perPage: 1000,
      };
      this.$store
        .dispatch('_getProjects', this.formatQueryParams(body))
        .then((resp) => {
          resp.data.map((e) => {
            if (this.showArquivded) {
              this.projects.push({
                id: e.id,
                name: `${e.project_code} - ${e.project_name} ${
                  e.is_archived ? '(Arquivado)' : ''
                }`,
              });
            } else {
              if (e.is_archived) {
                return null;
              } else {
                this.projects.push({
                  id: e.id,
                  name: `${e.project_code} - ${e.project_name} ${
                    e.is_archived ? '(Arquivado)' : ''
                  }`,
                });
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleShowArquived() {
      this.showArquivded = !this.showArquivded;
      this.projects = [];
      this.getProjects();
    },

    async updateItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }
      let value = this.monetaryToNumber(this.item.value);
      let newInstallmentLength = this.installments.length;

      let revenueValue = parseInt(value / newInstallmentLength);

      const newInstallmentValue = revenueValue;
      const newInstallment = [];

      if (this.installments.length > 0) {
        for (let i = 1; i <= newInstallmentLength; i++) {
          newInstallment.push({
            value: newInstallmentValue,
            transaction_date: this.item.transaction_date,
          });
        }
      }

      this.$store
        .dispatch('updateExpense', {
          installments: newInstallment,
          value: value,
          reference_date: this.item.reference_date,
          transaction_date: this.item.transaction_date,
          status: this.item.status,
          description: this.item.description,
          id: this.item.id,
          supplier_id: this.item.supplier_id,
          expense_category_id: this.item.expense_category_id,
          project_id: this.item?.project_id || null,
        })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Despesa alterada com sucesso.',
              icon: 'SuccessIcon',
              variant: 'success',
            },
          });
          if (this.id) {
            this.$emit('closeModal');
          } else {
            this.$router.push({
              name: 'lancamento-de-receita',
            });
          }
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao alterar receita.',
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },
    async getCategories() {
      const params = {
        inactive: false,
        workspace_id: this.$store.getters.currentWorkspace.id,
        cost_category: this.is_project_expense ? 'project' : null,
        page: this.page,
        perPage: 1000,
      };

      try {
        const resp = await this.$store.dispatch('getAllCostsCategory', params);

        if (resp && resp.data) {
          this.categories = [...this.categories, ...resp.data];
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style>
.justify-center {
  display: flex;
  justify-content: center;
}
td::before {
  float: none !important;
}
</style>
